import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import DropTarget from '../../../components/DriveItemList/DropTarget';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, routerParamsHistory } = state;
	const { applicationGallery } = galleryInfos.config;

	return {
		folderId: Utils.getCurrentFolderId(applicationGallery, routerParamsHistory),
	};
};

export default connect(mapStateToProps)(DropTarget);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/DropTarget/index.tsx